import { WithClassName } from "shared/types/WithClassName"

import { Team } from "entities/teams/types/Team"

import { useProjectTeamPopoverViewModel } from "./model/useProjectTeamPopoverViewModel"
import "./styles/_project-team-popover.scss"
import { ProjectTeamPopoverView } from "./ui/ProjectTeamPopoverView"

export interface ProjectTeamPopoverModel {
  team: Team | null | undefined
  email?: string | null
  onManage?: () => void
}

export interface ProjectTeamPopoverProps
  extends ProjectTeamPopoverModel,
    WithClassName {
  defaultOpen?: boolean
  popoverClassName?: string
}

export function ProjectTeamPopover(props: ProjectTeamPopoverProps) {
  return <ProjectTeamPopoverView {...useProjectTeamPopoverViewModel(props)} />
}
